import { ApiClient } from "client/base";
import { CommentableType } from "types/base";
const TYPE_PREFIX_MAP = {
    [CommentableType.COMMENT]: "comments",
    [CommentableType.PROJECT_ASSUMPTION]: "project_assumptions",
    [CommentableType.PROJECT_SCENARIO]: "project_scenarios",
    [CommentableType.PROJECT_SEGMENT_ASSUMPTION]: "project_segment_assumptions",
    [CommentableType.PROJECT_TASK]: "project_tasks",
    [CommentableType.TRAINING]: "data",
    [CommentableType.REPORT]: "reports",
    [CommentableType.REPORT_CHART]: "report_charts"
};
export class CommentClient extends ApiClient {
    getComment(commentId) {
        return this.base.get(`comments/${commentId}`);
    }
    getComments(type, id) {
        return this.base.get(`${TYPE_PREFIX_MAP[type]}/${id}/comments`);
    }
    updateComment(commentId, update) {
        return this.base.patch(`comments/${commentId}`, update);
    }
    deleteComment(commentId) {
        return this.base.delete(`comments/${commentId}`);
    }
    addCommentRating(commentId, rating) {
        return this.base.post(`comments/${commentId}/ratings`, rating);
    }
    addSubComment(commentId, comment) {
        return this.base.post(`comments/${commentId}/comments`, comment);
    }
}
